import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import ContainerPublic from '../base/ContainerPublic'
import { useToast } from '../controls/Toast/ToastService'
import { MdErrorOutline } from 'react-icons/md'
import { GetAll } from '../../configurations/crud/stateCrud'
import * as cityCrud from '../../configurations/crud/cityCrud'
import Switch from "react-switch";
import { GetAllByUserPublic, GetByCityWithActiveCenter } from '../../configurations/crud/opdCentersCrud'
import Dp from './users/Dp'
import { useFormik } from 'formik'
import { FaHospital } from "react-icons/fa6";
import { FaUserDoctor } from "react-icons/fa6";
import { IsMobileEnv, PUBLIC_PAGE_SIZE } from '../../configurations/initUrls'
import moment from 'moment'
import { SearchRandomUsers, SearchUserByCity } from '../../configurations/crud/applicationUserCrud'
import * as yup from 'yup'
import GlobalPaging from '../controls/GlobalPaging'
import { FaLockOpen } from "react-icons/fa6";
import Footer from '../base/Footer'
import Select from '../controls/Select'
import { FaMapLocationDot } from "react-icons/fa6";
import { IoLocation } from "react-icons/io5";
import useGlobalLoader from '../../configurations/useGlobalLoader'
import LoadingContainer from '../controls/LoadingContainer'
import Team from './Team'
import DoctorsCard from '../controls/DoctorsCard'
import Pricing from './Pricing'
import FabToggle from '../base/FabToggle'

export default function Home() {
    const { start, end } = useGlobalLoader()
    const [lodingStateCrud, setLodingStateCrud] = useState(false)
    const [stateData, setStateData] = useState([])
    const [lodingCityCrud, setLodingCityCrud] = useState(false)
    const [cityData, setCityData] = useState([]);
    const [searchType, setSearchType] = useState(0);
    const [user, setUser] = useState();
    const [loding, setLoding] = useState(false);
    const [centerData, setCenterData] = useState([]);
    const [userData, setUserData] = useState([]);
    const [LastPage, setLastPage] = useState(1);
    const [pagingData, setPagingData] = useState();
    const [searchCount, setSearchCount] = useState(1);
    const toast = useToast()

    const intiParam = {
        DoctorId: "9005954900"
    }

    const initSearch = {
        stateId: undefined,
        cityId: undefined,
        isCenter: 0,
        searchTerm: "",
        pageNo: 0,
        pageSize: PUBLIC_PAGE_SIZE,
    }
    const schemaSearch = yup.object().shape({
        stateId: yup.string().required("Please select state."),
        cityId: yup.string().required("Please select city."),
    })
    const { values, setValues, handleBlur, handleSubmit, handleChange, errors, touched, isValid } = useFormik({
        initialValues: initSearch,
        validationSchema: schemaSearch,
        onSubmit(val) {
            setValues(pre => ({
                ...pre,
                pageNo: 1,
            }))
            setSearchCount(pre => pre + 1)
        }
    })

    useEffect(() => {
        GetStates()
        getDoctorsRandom()
    }, [])

    useEffect(() => {
        setValues({
            ...values,
            pageNo: 0,
        })
        setUserData([])
        setCenterData([])
        setPagingData()
        setLastPage(1)
    }, [values.isCenter])

    useEffect(() => {
        if (values.stateId)
            GetCities(values.stateId)
    }, [values.stateId])

    useEffect(() => {
        if (values.pageNo > 0)
            if (values.isCenter == 1) {
                getCenters(values)
                setUserData([])
            } else {
                getDoctors(values)
                setCenterData([])
            }
    }, [values.pageNo, searchCount])

    const GetStates = () => {
        setLodingStateCrud(true)
        start()
        GetAll().then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setStateData(mdata.data)
            } else {
                setStateData([])
                toast.open(mdata.result.message, <MdErrorOutline />, "danger")
            }
            setLodingStateCrud(false)
            end()
        }).catch(errors => {
            setStateData([])
            setLodingStateCrud(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    const GetCities = (id) => {
        setLodingCityCrud(true)
        start()
        cityCrud.GetAll(id).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setCityData(mdata.data)
            } else {
                setCityData([])
                // toast.open(mdata.result.message, <MdErrorOutline />, "danger")
            }
            setLodingCityCrud(false)
            end()
        }).catch(errors => {
            setCityData([])
            // toast.open(errors, <MdErrorOutline />, "danger")
            setLodingCityCrud(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    const getDoctors = (val) => {
        setLoding(true)
        start()
        SearchUserByCity({
            PageNo: val.pageNo,
            PageSize: val.pageSize,
            SearchTerm: val.searchTerm,
            CityId: val.cityId
        }).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setUserData(mdata.data)
                setPagingData(mdata.paging)
                setLastPage(mdata.paging.pageCount)
            } else {
                setPagingData()
                setLastPage(1)
                setUserData([])
                toast.open(mdata.result.message, <MdErrorOutline />, "danger")
            }
            setLoding(false)
            end()
        }).catch(errors => {
            setPagingData()
            setLastPage(1)
            setUserData([])
            setLoding(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }
    const getDoctorsRandom = () => {
        setLoding(true)
        start()
        SearchRandomUsers({
            count: 6
        }).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setUserData(mdata.data)
            } else {
                setUserData([])
                //toast.open(mdata.result.message, <MdErrorOutline />, "danger")
            }
            setLoding(false)
            end()
        }).catch(errors => {
            setUserData([])
            setLoding(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }
    const getCenters = (val) => {
        setLoding(true)
        start()
        GetByCityWithActiveCenter(
            {
                PageNo: val.pageNo,
                PageSize: val.pageSize,
                SearchTerm: val.searchTerm,
                CityId: val.cityId
            }).then(res => {
                let mdata = res.data
                if (mdata.result.succeeded) {
                    setCenterData(mdata.data)
                    setPagingData(mdata.paging)
                    setLastPage(mdata.paging.pageCount)
                } else {
                    setPagingData()
                    setLastPage(1)
                    setCenterData([])
                    toast.open(mdata.result.message, <MdErrorOutline />, "danger")
                }
                setLoding(false)
                end()
            }).catch(errors => {
                setPagingData()
                setLastPage(1)
                setCenterData([])
                setLoding(false)
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            })
    }

    const OnPageChange = (e) => {
        const { value } = e.target;
        // setValues({
        //     ...values,
        //     pageNo: value,
        // })
        setValues(pre => ({
            ...pre,
            pageNo: value,
        }))
    }
    return (
        <ContainerPublic>
            <div className="min-h-screen flex flex-col text-gray-800">
                <div className="fixed w-full z-40 bg-white border border-gray-200 shadow-lg py-2 pe-4 flex gap-2 justify-between">
                    <Link to="/" className='ms-3 flex items-center'>
                        <img
                            alt="Doctora OPD"
                            src="/assets/images/logo.png"
                            className="mx-auto h-9 w-auto"
                        />
                    </Link>
                    <div className='flex items-end'>
                        {/* <Link to="/create-doctor">
                            <button className="text-sm flex justify-center items-end py-1 pe-2 hover:text-blue-800 text-blue-600 ">
                                <span className='hidden sm:block ms-1'>Register as Doctor?</span>
                                <span className='sm:hidden ms-1'>Register?</span>
                            </button>
                        </Link> */}
                        <Link to="/login">
                            <button className="group relative px-5 py-2 rounded-lg bg-sky-500 shadow hover:bg-sky-600 text-white transition duration-300">
                                <span className="absolute left-3 top-1/2 transform -translate-y-1/2 opacity-0 group-hover:opacity-100 transition duration-300">
                                    <FaLockOpen />
                                </span>
                                <span className="group-hover:ml-5 transition-all duration-300">Login</span>
                            </button>
                        </Link>
                    </div>
                </div>
                <div className='pt-[59px]'></div>

                <section className="bg-blue-100 px-6 pt-4 pb-6 lg:px-20 text-center ">


                    <p className="text-sm max-w-3xl mx-auto mb-4 sm:text-lg text-gray-700 italic font-semibold opacity-0 animate-fade-in delay-[0ms]">
                        <span className='text-sky-500'>Digital</span> OPD to <span className='text-green-500'>Connect</span> with <span className='text-red-500'>Doctors</span>, manage schedules, and simplify healthcare.
                    </p>
                    <form onSubmit={handleSubmit} className='w-full flex flex-col items-center justify-center'>
                        <div className='w-full md:w-8/12 flex flex-col items-center justify-center'>
                            <div className="w-full grid grid-cols-12 gap-4 items-end">
                                {/* State Dropdown */}
                                <div className="col-span-12 sm:col-span-6">
                                    {!lodingStateCrud ? (
                                        <Select
                                            Icon={<FaMapLocationDot className='text-green-600 text-lg' />}
                                            id="stateId"
                                            value={values.stateId}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isError={errors.stateId && touched.stateId}
                                        >
                                            <option value="">Select state...</option>
                                            {stateData.map((item) => (
                                                <option key={item.id} value={item.id}>{item.name} ({item.shortName})</option>
                                            ))}
                                        </Select>
                                    ) : (
                                        <Select
                                            Icon={<FaMapLocationDot className='text-green-600 text-lg' />} disabled>
                                            <option>Loading states...</option>
                                        </Select>
                                    )}
                                </div>

                                {/* City Dropdown */}
                                <div className="col-span-12 sm:col-span-6">
                                    {!lodingCityCrud ? (
                                        <Select
                                            Icon={<IoLocation className='text-sky-600 text-lg' />}
                                            id="cityId"
                                            value={values.cityId}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isError={errors.cityId && touched.cityId}
                                        >
                                            <option value="">Select city...</option>
                                            {cityData.map((item) => (
                                                <option key={item.id} value={item.id}>{item.name} ({item.shortName})</option>
                                            ))}
                                        </Select>
                                    ) : (
                                        <Select
                                            Icon={<IoLocation className='text-sky-600 text-lg' />} disabled>
                                            <option>Loading cities...</option>
                                        </Select>
                                    )}
                                </div>


                            </div>
                            {/* Search Input + Button */}
                            <div className="w-full grid grid-cols-12 gap-4 items-end mt-4">
                                <div className="col-span-12">
                                    <div className="flex w-full border border-gray-300 focus:border-blue-300 bg-white rounded-l-md rounded-r-lg">
                                        <div className='border-l border-gray-300'>
                                            <Switch
                                                id='isCenter'
                                                checked={values.isCenter == 1}
                                                onChange={(e) => setValues({ ...values, isCenter: values.isCenter == 1 ? 0 : 1 })}
                                                offColor="#fff"
                                                onColor="#fff"
                                                offHandleColor="#299ee1"
                                                onHandleColor="#53b73a"
                                                height={40}
                                                width={100}
                                                borderRadius={6}
                                                checkedIcon={
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            height: "100%",
                                                            fontSize: 15,
                                                            paddingRight: 2
                                                        }}
                                                    >
                                                        Center
                                                    </div>

                                                }
                                                checkedHandleIcon={
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            height: "100%",
                                                            color: "#fff",
                                                            fontSize: 18
                                                        }}
                                                    >
                                                        <FaHospital />
                                                    </div>
                                                }
                                                uncheckedHandleIcon={
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            height: "100%",
                                                            color: "#fff",
                                                            fontSize: 18
                                                        }}
                                                    >
                                                        <FaUserDoctor />
                                                    </div>
                                                }
                                                uncheckedIcon={
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            height: "100%",
                                                            fontSize: 15,
                                                            paddingRight: 2
                                                        }}
                                                    >
                                                        Doctor
                                                    </div>
                                                }
                                                className="react-switch"
                                            />
                                        </div>
                                        <input
                                            id="searchTerm"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className=" outline-none text-gray-900 text-sm   block w-full p-2.5 border-l border-gray-300"
                                            placeholder={`Search by ${values.isCenter == 1 ? "Center" : "Doctor"}....`}
                                        />
                                        {isValid ?
                                            loding ?
                                                <button
                                                    disabled
                                                    className="p-2.5 text-sm font-medium bg-sky-400 rounded-r-lg border border-sky-600"
                                                >
                                                    <svg aria-hidden="true" class="w-4 h-4 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                                    </svg>
                                                </button>
                                                :
                                                <button
                                                    type="submit"
                                                    className="p-2.5 text-sm font-medium text-white bg-sky-500 rounded-r-lg border border-sky-600 hover:bg-sky-600 focus:ring-4 focus:outline-none focus:ring-blue-300"
                                                >
                                                    <svg className="w-4 h-4" fill="none" viewBox="0 0 20 20">
                                                        <path
                                                            stroke="currentColor"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            strokeWidth="2"
                                                            d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                                                        />
                                                    </svg>
                                                </button>
                                            :
                                            <button
                                                disabled
                                                className="p-2.5 text-sm font-medium text-white bg-gray-400 rounded-r-lg border border-gray-500 cursor-not-allowed"
                                            >
                                                <svg className="w-4 h-4" fill="none" viewBox="0 0 20 20">
                                                    <path
                                                        stroke="currentColor"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth="2"
                                                        d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                                                    />
                                                </svg>
                                                <span className="sr-only">Search</span>
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>


                </section>
                <div className='flex flex-col justify-between grow'>

                    <section className="py-8 px-6 md:px-20 bg-slate-100">

                        {loding ?
                            <>
                                {/* <h2 className="text-3xl font-semibold text-center text-blue-600 mb-6">Please wait finding {values.isCenter == 1 ? "centers" : "doctors"}...</h2> */}
                                <div>
                                    <LoadingContainer text={"Finding doctors"} />
                                </div>
                            </>
                            :
                            <>
                                {/* <h2 className="text-2xl text-center text-blue-600 mb-6">Search result for {values.isCenter == 1 ? "Centers" : "Doctors"}</h2> */}
                                <GlobalPaging text={values.isCenter == 1 ? "Centers" : "Doctors"} LastPage={LastPage} CurrentPage={values.pageNo} OnPageChange={OnPageChange} pagingData={pagingData} loading={loding}>
                                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
                                        {values.isCenter == 1 ?
                                            <>
                                                {centerData.length > 0 ?
                                                    centerData.map(item =>
                                                        <>
                                                            <DoctorsCard item={item.user} isCenter={true} center={item} />
                                                        </>
                                                    )
                                                    :
                                                    <h2 className="col-span-full text-2xl font-semibold text-center text-gray-300 ">No {values.isCenter == 1 ? "Centers" : "Doctors"} Found</h2>
                                                }
                                            </>
                                            :
                                            <>
                                                {userData.length > 0 ?
                                                    userData.map(item =>
                                                        <>
                                                            <DoctorsCard item={item} />
                                                        </>
                                                    )
                                                    :
                                                    <h2 className="col-span-full text-2xl font-semibold text-center text-gray-300 ">No {values.isCenter == 1 ? "Centers" : "Doctors"} Found</h2>
                                                }
                                            </>

                                        }

                                    </div>
                                </GlobalPaging>

                            </>
                        }
                    </section>
                    {!IsMobileEnv &&
                        <section>
                            <Pricing />
                        </section>}
                    <section className='h-full'>
                        <Team />
                    </section>
                    <section>
                        <Footer />
                    </section>
                </div>
            </div >

            <FabToggle />
        </ContainerPublic>
    )
}
